import { getAccessToken } from './tokenManager';
import tokenInvalidationService from './tokenInvalidationService';
import BrowserSecurityService from './browserSecurityService';
import cacheControlService from './cacheControlService';

export const getCurrentUser = () => {
  const userEmail = sessionStorage.getItem('userEmail');
  const userToken = sessionStorage.getItem('userToken');
  const userName = sessionStorage.getItem('userName');
  
  // Check if token is blacklisted
  if (userToken && tokenInvalidationService.isTokenBlacklisted(userToken)) {
    console.warn('[Auth] Current token is blacklisted, clearing user session');
    clearCurrentUser();
    return null;
  }
  
  if (userEmail && userToken) {
    return {
      email: userEmail,
      token: userToken,
      name: userName
    };
  }
  return null;
};

export const getCurrentUserEmail = () => {
  // Supplier logic: return supplier email if user is a supplier
  const isSupplier = sessionStorage.getItem('user_type') === 'supplier';
  if (isSupplier) {
    return sessionStorage.getItem('supplierEmail') || null;
  }
  return sessionStorage.getItem('userEmail') || null;
};

export const getCurrentUserName = () => {
  return sessionStorage.getItem('userName') || null;
};

export const setCurrentUser = (email, token, name) => {
  sessionStorage.setItem('userEmail', email);
  sessionStorage.setItem('userToken', token);
  if (name) sessionStorage.setItem('userName', name);
};

export const clearCurrentUser = async () => {
  const currentUser = getCurrentUser();
  
  // Invalidate token before clearing if user exists
  if (currentUser && currentUser.token) {
    try {
      await tokenInvalidationService.invalidateToken(currentUser.token, currentUser.email);
    } catch (error) {
      console.error('[Auth] Failed to invalidate token during clearCurrentUser:', error);
    }
  }
  
  // Clear cache and sensitive data
  if (cacheControlService.isInitialized) {
    cacheControlService.clearSensitiveCache();
  }
  
  // Set browser security logout state
  BrowserSecurityService.handleLogout();
  
  // Clear session storage items
  sessionStorage.removeItem('userEmail');
  sessionStorage.removeItem('userToken');
  sessionStorage.removeItem('userName');
  sessionStorage.removeItem('supplierEmail');
  sessionStorage.removeItem('user_type');
  

};

// Supplier logic: store supplier email in sessionStorage
export const setSupplierEmail = (email) => {
  sessionStorage.setItem('supplierEmail', email);
};

// Supplier logic: retrieve supplier email from sessionStorage
export const getSupplierEmail = () => {
  return sessionStorage.getItem('supplierEmail') || null;
};

// Enhanced token validation
export const validateCurrentToken = async () => {
  const user = getCurrentUser();
  if (!user || !user.token) {
    return false;
  }
  
  // Check client-side blacklist first
  if (tokenInvalidationService.isTokenBlacklisted(user.token)) {
    console.warn('[Auth] Token is blacklisted');
    await clearCurrentUser();
    return false;
  }
  
  // Verify with server
  const isValid = await tokenInvalidationService.verifyTokenValidity(user.token);
  if (!isValid) {
    console.warn('[Auth] Token validation failed');
    await clearCurrentUser();
    return false;
  }
  
  return true;
};

// Secure logout function
export const secureLogout = async (msalInstance) => {
  const user = getCurrentUser();
  if (user) {
    // Clear cache and sensitive data before logout
    if (cacheControlService.isInitialized) {
      cacheControlService.forceCleanAllCache();
    }
    
    // Set browser security logout state before clearing
    BrowserSecurityService.handleLogout();
    await tokenInvalidationService.secureLogout(msalInstance, user.token, user.email);
  } else {
    // No user found, still clear everything and set logout state
    if (cacheControlService.isInitialized) {
      cacheControlService.forceCleanAllCache();
    }
    BrowserSecurityService.handleLogout();
    tokenInvalidationService.clearAllLocalStorage();
    window.location.href = '/login';
  }
};
